import React, { useState, useEffect } from "react";
import { personaIcons } from "../utils/personas/personaIcons";

interface IPersonaProps {
  icon: string;
  text: string;
  clicked?: boolean;
  onClick: () => void;
}

const Persona = ({ icon, text, clicked, onClick }: IPersonaProps) => {
  return (
    <button
      onClick={onClick}
      className={`btn btn-large btn-persona ${
        clicked && "btn-persona-clicked"
      }`}
    >
      <div className="icon-container">
        <img className="icon" src={personaIcons[icon]} />
      </div>
      <div className="text-main persona-label">{text}</div>
    </button>
  );
};

export default Persona;
